import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';

/**
 * Временное решение, пока данный функционал не будет реализован в @cian/experiments
 *
 * Функция, возвращает код в обертках групп A/B эксперимента
 * Если эксперимент не активен код контрольной группы не будет обернут в группу эксперимента
 * Нужно чтобы избежать запроса групп в случае когда эксперимент не активен
 *
 * @param isActive
 * @param experimentName
 * @param controlGroup
 * @param experimentGroup
 */
export const experimentToggle = (
  isActive: boolean,
  experimentName: string,
  controlGroup?: React.ReactNode,
  experimentGroup?: React.ReactNode,
) => {
  if (!isActive) {
    return controlGroup || null;
  }

  return (
    <>
      {controlGroup && (
        <Experiment name={experimentName} group="A" default>
          {controlGroup}
        </Experiment>
      )}
      {experimentGroup && (
        <Experiment name={experimentName} group="B">
          {experimentGroup}
        </Experiment>
      )}
    </>
  );
};
